import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import { Link, useListContext } from "react-admin";
import { hmLightTheme } from "../themes/hmTheme";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";

const AppMenuTitle = ({ ...props }) => {
  const type = props.type;
  const appCounts = props.count;
  let chipBgColor = "rgba(0, 0, 0, 0.08)";
  let textColor = "#000";
  let textBold = "normal";
  let titleColor = "gray";
  if (type == "Total Borrowers" || type == "Total Applicants") {
    textBold = "bold";
    titleColor = "#000";
  }

  let showTitle = type;
  if (showTitle == "Less Than 30D Late Borrowers") {
    showTitle = "< 30D Delinquent Borrowers";
  } else if (showTitle == "30D Delinquent Borrowers") {
    showTitle = "> 30D Delinquent Borrowers";
  } else if (showTitle == "60D Delinquent Borrowers") {
    showTitle = "> 60D Delinquent Borrowers";
  } else if (showTitle == "90D Delinquent Borrowers") {
    showTitle = "> 90D Delinquent Borrowers";
  }

  if (showTitle.includes("Sign-Ups in ")) {
    chipBgColor = "gray";
    textColor = "#fff";
    titleColor = "#000";
  }
  return (
    <Box component="span" sx={{ width: "100%", display: "inline-block" }}>
      {showTitle.includes("Sign-Ups in ") ? (
        <span
          style={{
            fontWeight: "bold",
            color: "#000",
          }}
        >
          {showTitle}
        </span>
      ) : (
        <span style={{ fontWeight: textBold, color: titleColor }}>
          {showTitle}
        </span>
      )}

      <Chip
        label={appCounts}
        component="span"
        size="small"
        className="numericText"
        sx={{
          ml: 1,
          float: "right",
          fontFamily: hmLightTheme?.palette?.numberFontFamily,
          backgroundColor: chipBgColor,
          color: textColor,
        }}
      />
    </Box>
  );
};

const CustomerYearListAside = ({ ...props }) => {
  const { filterValues } = useListContext();
  const status = filterValues.status;
  const totalData = props.totalData;

  return (
    <>
      <HmSubHeaderTitle
        title="Customers"
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent sx={{ pt: 1 }}>
          <MenuList component="div" id="list-customer-menus">
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Sign-Ups in 2026 to Date
              <Chip
                label={
                  totalData.signUp2026_campaigns +
                  totalData.signUp2026_counselors +
                  totalData.signUp2026_direct +
                  totalData.signUp2026_other
                }
                size="small"
                className="numericText"
                sx={{
                  pt: "5px",
                  mr: "0.2em",
                  display: "block",
                  float: "right",
                  fontFamily: hmLightTheme?.palette?.numberFontFamily,
                  backgroundColor: "#00000014",
                  color: "#000",
                  fontWeight: "normal",
                }}
              />
            </Typography>
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2026_campaigns"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Campaigns"
                  count={totalData.signUp2026_campaigns}
                />
              }
              tooltipProps={{
                title: "Campaigns",
                children: <></>,
              }}
              selected={status === "signUp2026_campaigns"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2026_counselors"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Counselors"
                  count={totalData.signUp2026_counselors}
                />
              }
              tooltipProps={{
                title: "Counselors",
                children: <></>,
              }}
              selected={status === "signUp2026_counselors"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2026_direct"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Direct"
                  count={totalData.signUp2026_direct}
                />
              }
              tooltipProps={{
                title: "Direct",
                children: <></>,
              }}
              selected={status === "signUp2026_direct"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2026_other"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Other" count={totalData.signUp2026_other} />
              }
              tooltipProps={{
                title: "Other",
                children: <></>,
              }}
              selected={status === "signUp2026_other"}
            />
            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Sign-Ups in 2025 to Date
              <Chip
                label={
                  totalData.signUp2025_campaigns +
                  totalData.signUp2025_counselors +
                  totalData.signUp2025_direct +
                  totalData.signUp2025_other
                }
                size="small"
                className="numericText"
                sx={{
                  pt: "5px",
                  mr: "0.2em",
                  display: "block",
                  float: "right",
                  fontFamily: hmLightTheme?.palette?.numberFontFamily,
                  backgroundColor: "#00000014",
                  color: "#000",
                  fontWeight: "normal",
                }}
              />
            </Typography>
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2025_campaigns"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Campaigns"
                  count={totalData.signUp2025_campaigns}
                />
              }
              tooltipProps={{
                title: "Campaigns",
                children: <></>,
              }}
              selected={status === "signUp2025_campaigns"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2025_counselors"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Counselors"
                  count={totalData.signUp2025_counselors}
                />
              }
              tooltipProps={{
                title: "Counselors",
                children: <></>,
              }}
              selected={status === "signUp2025_counselors"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2025_direct"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Direct"
                  count={totalData.signUp2025_direct}
                />
              }
              tooltipProps={{
                title: "Direct",
                children: <></>,
              }}
              selected={status === "signUp2025_direct"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2025_other"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Other" count={totalData.signUp2025_other} />
              }
              tooltipProps={{
                title: "Other",
                children: <></>,
              }}
              selected={status === "signUp2025_other"}
            />
            <hr />
            {/* SignUp2024 */}
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Sign-Ups in 2024
              <Chip
                label={
                  totalData.signUp2024_campaigns +
                  totalData.signUp2024_counselors +
                  totalData.signUp2024_direct +
                  totalData.signUp2024_other
                }
                size="small"
                className="numericText"
                sx={{
                  pt: "5px",
                  mr: "0.2em",
                  display: "block",
                  float: "right",
                  fontFamily: hmLightTheme?.palette?.numberFontFamily,
                  backgroundColor: "#00000014",
                  color: "#000",
                  fontWeight: "normal",
                }}
              />
            </Typography>

            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2024_campaigns"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Campaigns"
                  count={totalData.signUp2024_campaigns}
                />
              }
              tooltipProps={{
                title: "Campaigns",
                children: <></>,
              }}
              selected={status === "signUp2024_campaigns"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2024_counselors"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Counselors"
                  count={totalData.signUp2024_counselors}
                />
              }
              tooltipProps={{
                title: "Counselors",
                children: <></>,
              }}
              selected={status === "signUp2024_counselors"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2024_direct"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Direct"
                  count={totalData.signUp2024_direct}
                />
              }
              tooltipProps={{
                title: "Direct",
                children: <></>,
              }}
              selected={status === "signUp2024_direct"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2024_other"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Other" count={totalData.signUp2024_other} />
              }
              tooltipProps={{
                title: "Other",
                children: <></>,
              }}
              selected={status === "signUp2024_other"}
            />
            <hr />
            {/* SignUp2023 */}
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Sign-Ups in 2023
              <Chip
                label={
                  totalData.signUp2023_campaigns +
                  totalData.signUp2023_counselors +
                  totalData.signUp2023_direct +
                  totalData.signUp2023_other
                }
                size="small"
                className="numericText"
                sx={{
                  pt: "5px",
                  mr: "0.2em",
                  display: "block",
                  float: "right",
                  fontFamily: hmLightTheme?.palette?.numberFontFamily,
                  backgroundColor: "#00000014",
                  color: "#000",
                  fontWeight: "normal",
                }}
              />
            </Typography>
            {/* <CustomMenuItemLink
              to=""
              state={{ _scrollToTop: true }}
              // primaryText={"Sign-Up in 2023"}
              primaryText={
                <AppMenuTitle
                  type="Sign-Ups in 2023"
                  count={
                    totalData.signUp2023_campaigns +
                    totalData.signUp2023_counselors +
                    totalData.signUp2023_direct +
                    totalData.signUp2023_other
                  }
                />
              }
              disabled
            /> */}
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2023_campaigns"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Campaigns"
                  count={totalData.signUp2023_campaigns}
                />
              }
              tooltipProps={{
                title: "Campaigns",
                children: <></>,
              }}
              selected={status === "signUp2023_campaigns"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2023_counselors"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Counselors"
                  count={totalData.signUp2023_counselors}
                />
              }
              tooltipProps={{
                title: "Counselors",
                children: <></>,
              }}
              selected={status === "signUp2023_counselors"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2023_direct"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Direct"
                  count={totalData.signUp2023_direct}
                />
              }
              tooltipProps={{
                title: "Direct",
                children: <></>,
              }}
              selected={status === "signUp2023_direct"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2023_other"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Other" count={totalData.signUp2023_other} />
              }
              tooltipProps={{
                title: "Other",
                children: <></>,
              }}
              selected={status === "signUp2023_other"}
            />
            <hr />
            {/* SignUp2022 */}
            {/* <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Sign-Ups in 2022
              <Chip
                label={
                  totalData.signUp2022_campaigns +
                  totalData.signUp2022_counselors +
                  totalData.signUp2022_direct +
                  totalData.signUp2022_other
                }
                size="small"
                className="numericText"
                sx={{
                  pt: "5px",
                  mr: "0.2em",
                  display: "block",
                  float: "right",
                  fontFamily: hmLightTheme?.palette?.numberFontFamily,
                  backgroundColor: "#00000014",
                  color: "#000",
                  fontWeight: "normal",
                }}
              />
            </Typography>
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2022_campaigns"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Campaigns"
                  count={totalData.signUp2022_campaigns}
                />
              }
              tooltipProps={{
                title: "Campaigns",
                children: <></>,
              }}
              selected={status === "signUp2022_campaigns"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2022_counselors"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Counselors"
                  count={totalData.signUp2022_counselors}
                />
              }
              tooltipProps={{
                title: "Counselors",
                children: <></>,
              }}
              selected={status === "signUp2022_counselors"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2022_direct"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Direct"
                  count={totalData.signUp2022_direct}
                />
              }
              tooltipProps={{
                title: "Direct",
                children: <></>,
              }}
              selected={status === "signUp2022_direct"}
            />
            <CustomMenuItemLink
              to='/customers?filter={"status":"signUp2022_other"}'
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Other" count={totalData.signUp2022_other} />
              }
              tooltipProps={{
                title: "Other",
                children: <></>,
              }}
              selected={status === "signUp2022_other"}
            /> 
            <hr />
            */}
            <CustomMenuItemLink
              to={`/reports?filter={"status":"Inception to Date","reportType":"customers"}`}
              state={{ _scrollToTop: true }}
              primaryText={"Download More Customer Data"}
              sx={{ "& .MuiTypography-root": { color: "#1976d2" } }}
            />
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default CustomerYearListAside;
